import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery;


export class ZIDXAccountCrmConnections implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCrmConnectionsContainer";
    }
    render(){
        // console.log("CRM Connections");
    }
}
